var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "accordion-wrapper",
      on: {
        "open-parent-accordion": function($event) {
          return _vm.openAccordion()
        }
      }
    },
    [
      _c(
        "ui-accordion",
        { attrs: { "is-passive": true, "is-open": _vm.isOpen } },
        [
          _c("template", { slot: "head" }, [
            _c(
              "div",
              {
                staticClass: "accordion-wrapper--head",
                on: { click: _vm.toggleAccordion }
              },
              [
                _c("ui-icon", {
                  staticClass: "ui-accordion--icon",
                  attrs: {
                    symbol: _vm.isOpen ? "remove" : "add",
                    size: "medium"
                  }
                }),
                _vm._v(" "),
                _c(
                  "h2",
                  {
                    staticClass: "ui-accordion--title u-reset",
                    attrs: { id: _vm.anchor }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.title) +
                        "\n                "
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("template", { ref: "body", slot: "body" }, [_vm._t("default")], 2)
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dbefa22", { render: render, staticRenderFns: staticRenderFns })
  }
}